import { Component, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef, Renderer2, OnInit, OnDestroy, AfterViewChecked, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { InventoryLocationXrefBus } from '../../../shared/models/InventoryLocationXrefBus';
import { InventoryReference } from '../../../shared/models/InventoryReference';
import { SaveMode } from '../../../shared/enums/SaveMode';
import { InventoryXferHistory } from '../../../shared/models/InventoryXferHistory';
import { Subscription } from 'rxjs';
import { GItem } from '../../../shared/models/GItem';
import { CRUDActions } from '../../../shared/enums/CRUDActions';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { DispatchData } from '@app/cp/shared/models/DispatchData';
import { GridDataResult, PageChangeEvent, ScrollMode } from '@progress/kendo-angular-grid';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'part-inventory',
    templateUrl: './part-inventory.component.html',
    styleUrls: ['./part-inventory.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PartInventoryComponent extends BaseGridEditLineComponent<InventoryLocationXrefBus, null, InventoryService> implements OnInit, OnDestroy, AfterViewInit, OnChanges {
    @Output() showInactiveChanged: EventEmitter<boolean> = new EventEmitter();
    @Output() showMainOnlyChanged: EventEmitter<boolean> = new EventEmitter();
    @Input() inventoryReferenceData: InventoryReference;
    @Input() allowMainFiltering: boolean = false;
    @Input() partNumber: String = "";
    @Input() summaryText: String = "";
    override processGridData() {
        this.loadData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['inventoryReferenceData']) {
            const currentValue = changes['inventoryReferenceData'].currentValue;
            const previousValue = changes['inventoryReferenceData'].previousValue;

            if (currentValue !== previousValue) {
                // Handle the change here
                this.handleInventoryReferenceDataChange(currentValue);
            }
        }
    }

    private handleInventoryReferenceDataChange(newData: InventoryReference): void {
        if (newData) {
            this.activeLocations = this.activeOrSelected(
                newData.inventoryLocations,
                this.selectedData?.inventoryLocationId
            );
        }
    }

    public pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.loadData();
    }
    gridView: GridDataResult;
    scrollableMode: ScrollMode = "scrollable";
    isVirtual: boolean = false;
    showInactive: boolean = false;
    showMainOnly: boolean = true;
    sort: SortDescriptor[] = [];
    private loadData(): void {
        if (this.isVirtual) {
            this.pageSize = 100;
        }
        else {
            this.pageSize = this.gridData.length;
        }
        let gData = null;
        if (this.sort && this.sort.length > 0) {
            gData = orderBy(this.gridData, this.sort);
        }
        else {
            gData = this.gridData;
        }
        this.gridView = {
            data: gData.slice(this.skip, this.skip + this.pageSize),
            total: this.gridData.length,
        };
    }


    protected override removeLocal(data: InventoryLocationXrefBus) {
        super.removeLocal(data);
        this.loadData();
        if (this.filter) {
            this.filterChange(this.filter);
        }
    }

    sortChanged(sc: SortDescriptor[]) {
        if (this.sort && this.sort.length > 0 && this.sort[0].field == sc[0].field) {
            if (this.sort[0].dir == "asc") {
                sc[0].dir = "desc";
            }
            else if (this.sort[0].dir == "desc") {
                sc = null;
            }
        }
        this.sort = sc;
        this.loadData();
    }
    onChangeShowInactive(value: boolean) {
        if (this.editForm) {
            this.cancelHandler();
        }
        this.showInactiveChanged.emit(value);
    }
    onChangeShowMainOnly
        (value: boolean) {
        if (this.editForm) {
            this.cancelHandler();
        }
        this.showMainOnlyChanged.emit(value);
        this.processGridData(); 
    }
    public dqoiWindowData: DispatchData;
    gridStyle = { height: 'auto' };
    subs_data_History: Subscription;
    activeLocations: GItem[] = [];
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "InventoryLocationXrefBus";
        this.appCode = "InventoryLocationXref";
        this.saveMode = SaveMode.all;
        this.skip = 0;
        this.disableCpSearchDialog();
    }
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};

    override ngOnInit(): void {
        super.ngOnInit();
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            //Defaults for scrollable is 'scrollable'
            if (this.featureFlagSet['inventory-parts-scrolling-behavior']) {
                this.scrollableMode = "virtual";
                this.isVirtual = true;
                this.gridStyle = { height: '860px' };
                this.pageSize = 100;
            }
            if (!this.featureFlagSet['warehouse-list-to-only-show-active-warehouses']) {
                this.showInactive = true;
            }
        });
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
        //If scrollable is 'virtual' must set rowHeight - needed here so grid is available
        if (this.isVirtual) {
            this.grid.rowHeight = 28;
        }
    }

    override createForm() {
        this.editForm = new UntypedFormGroup({
            'inventoryLocationId': new UntypedFormControl(null, Validators.required),
            'quantity': new UntypedFormControl(),
            'aisle': new UntypedFormControl(),
            'section': new UntypedFormControl(),
            'bin': new UntypedFormControl(),
            'warehouse': new UntypedFormControl(),
            'reason': new UntypedFormControl(),
            'onTurnQuantity': new UntypedFormControl(),
            'onOrderQuantity': new UntypedFormControl(),
            'dateAdded': new UntypedFormControl(new Date(), Validators.required),
        });

    }

    protected customPatchForm() {
        this.editForm.controls["warehouse"].setValue(this.inventoryReferenceData.getInventoryLocation(this.editForm.value.inventoryLocationId));
    }

    getTotal() {
        if (!this.gridData) {
            return 0;
        }
        var c = 0;
        this.gridData.forEach(function(obj) {
            c += obj["quantity"];

        });
        return c;

    }

    public onChangeQuantity(value: any) {
        //  if (this.selectedData && !this.selectedData.isAdded && (typeof this.selectedData.isAdded != 'undefined') ) {
        if (this.selectedData && (typeof this.selectedData.isAdded != 'undefined')) {
            if (this.selectedData.quantity != this.editForm?.value?.quantity && !this.selectedData.reason) {
                this.reason = "";
                this.showQuantityChanged = true;
                this.inventoryLocationXrefid = this.selectedData.inventoryLocationXrefid;
            }

        }
    }

    setForm() {
        var tempDate = new Date();
        if (this.selectedData.dateAdded) {
            tempDate = new Date(this.selectedData.dateAdded);
        }
        this.editForm.patchValue({
            inventoryLocationId: this.selectedData.inventoryLocationId,
            quantity: this.selectedData.quantity,
            section: this.selectedData.section,
            aisle: this.selectedData.aisle,
            bin: this.selectedData.bin,
            dateAdded: tempDate,
            reason: this.selectedData.reason,
            onOrderQuantity: this.selectedData.onOrderQuantity,
            onTurnQuantity: this.selectedData.onTurnQuantity,

        });
        this.handleInventoryReferenceDataChange(this.inventoryReferenceData);
    }
    showHistory: boolean = false;
    showQuantityChanged: boolean = false;
    reason: string = "";
    inventoryLocationXrefid: string = "";
    historyList: InventoryXferHistory[] = [];
    locationName: string = "";
    closeHistory() {
        this.showHistory = false;
    }

    get readOnlyPartQuantity(): boolean {
        if (this.readOnly) { return true; }
        if ((this.rights.EditPartQuantity || !this.selectedData.hasId || this.selectedData.isAdded)) { return false; }
        return true;
    }

    cancelQuantityAdjustment() {
        this.cancelHandler();
        this.globals.notifyInfo("Quantity adjustment cancelled.");
        this.showQuantityChanged = false;
    }

    closeReason() {
        if (this.editForm) {
            this.editForm.controls["reason"].setValue(this.reason);
        }
        this.selectedData.reason = this.reason;
        const index = this.gridData.findIndex(item => item.inventoryLocationXrefid === this.inventoryLocationXrefid);
        if (index > -1) {
            this.gridData[index].reason = this.reason;
            this.saveCurrent();
        } else {
            if (this.gridData?.length > 0) {
                this.gridData[0].reason = this.reason;
                this.saveCurrent();
            } else {
                this.saveCurrent();
                this.gridData[0].reason = this.reason;
            }
        }
        this.showQuantityChanged = false;
    }

    openHistory(inventoryLocationId: string, inventoryId: string) {
        this.locationName = this.inventoryReferenceData.getInventoryLocation(inventoryLocationId);
        if (this.subs_data_History !== undefined && this.subs_data_History !== null) {
            this.subs_data_History.unsubscribe();
        }
        this.historyList = [];
        this.subs_data_History = this.svc_data.getInventoryXferHistory(inventoryLocationId, inventoryId).subscribe(data => {
            this.historyList = data;
        });
        this.showHistory = true;
    }

    public locationChangePart(value: any): void {
        if (value != null) {
            var guid = "";
            if (this.selectedData) {
                guid = this.selectedData.CID();
            }

            if (this.originalData.some(e => e.inventoryLocationId === value && guid != e.inventoryLocationXrefid)) {
                this.cnfShow("Location is already being used. Would you like to select a different one?", CRUDActions.None, null, "Duplicate Warehouse", "DUPPARTCODE");
                this.editForm.patchValue({
                    inventoryLocationId: null
                });
            }
        }
    }

    details(data: any) {
        let searchBus: string = "";
        let searchTarget: number;
        let id: string = "";
        if (data.dispatchId) {
            searchBus = 'dispatch';
            searchTarget = SearchTarget.dispatch;
            id = data.dispatchId;
        } else if (data.invoiceId) {
            searchBus = 'invoice';
            searchTarget = SearchTarget.invoice;
            id = data.invoiceId;
        } else if (data.orderId) {
            searchBus = 'order';
            searchTarget = SearchTarget.order;
            id = data.orderId;
        }
        if (searchBus && searchTarget && id) {
            let url: string = `/quickview/${searchBus}/${searchTarget}/${id}`;
            this.navigate(url);
        }
    }
    showDetailsPopup(id: string, type: number) {
        let targetObj: DispatchData = new DispatchData();
        targetObj.id = id;
        targetObj.viewDispatch.dispatchId = id;
        targetObj.target = type;
        targetObj.targetCode = type.toString();
        this.dqoiPopup(targetObj, SearchTarget.invoice);
    }

    dqoiPopup(data: DispatchData, target: SearchTarget) {
        this.dqoiWindowData = data;
    }

    navigate(url: string) {
        setTimeout(() => {
            window.open(url, "_blank");
        });
    }
}
